import FleetSummaryPieChart from "views/admin/default/components/FleetSummaryPieChart";
import FleetSummaryDonutChart from "views/admin/default/components/FleetSummaryDonutChart";
import FleetViewTable from "views/admin/default/components/FleetViewTable";
import Card from "components/card";
import React, { useEffect } from "react";
import SliderTiles from "./components/SliderTiles";
import FleetSummaryLineChart from "./components/FleetSummaryLineGraph";
import FleetMap from "./components/FleetMap";
import { trackPageVisit } from "../../../utils/trackVisit";
import { readUser } from "utils/session";
import AccountImage from "components/AccountImage";

const Dashboard = () => {
  const loc = readUser();

  useEffect(() => {
    trackPageVisit();
  }, []);

  return (
    <div>

      <div className="mt-3 grid grid-cols-1 gap-5 md:grid-cols-3">
        {loc ? (
          <Card
            extra="!flex-row flex-grow items-center rounded-[6px] relative"
            style={{ height: "195px" }}
          >
            <div className="relative right-1 ml-[18px] flex h-[90px] w-[300px] flex-row items-center">
              <AccountImage alt="Account" className="max-h-[90px] max-w-[280px] object-contain" />
            </div>
          </Card>
        ) : (
          ""
        )}
        <div className="col-span-2">

        <SliderTiles />
        </div>
      </div>

      <div className="mt-5 grid grid-cols-1 gap-5 xl:grid-cols-1">
        <div>
          <FleetViewTable />
        </div>
        <div>
          <FleetMap />
        </div>
      </div>

      <div className="mt-5 grid grid-cols-1 gap-5 md:grid-cols-2">
        <FleetSummaryPieChart />
        <FleetSummaryDonutChart />
      </div>

      <div className="mt-5">
        <FleetSummaryLineChart />
      </div>

    </div>
  );
};

export default Dashboard;
